import {
  CreateDatasourceParams,
  DatasourceListViewData,
  DatasourceState,
  DatasourceStoreModel,
  DatasourceUIModel,
} from '@y42/datasource';
import { WithCredentials } from '@y42/impex';
import { IntegrationSettings } from '@y42/json-schema';

export class IntegrationSettingsGitModel extends IntegrationSettings {
  constructor(model: IntegrationStoreModel) {
    super();

    Object.assign(this, model.settings);
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class IntegrationStoreModel extends DatasourceStoreModel<IntegrationSettings> implements WithCredentials {
  constructor(model: IntegrationStoreModel) {
    super(model);
    this.secret = model.secret;
  }
  secret?: string;
}

export interface IntegrationUIModel extends DatasourceUIModel<IntegrationStoreModel> {}

export type IntegrationListViewData = DatasourceListViewData;

export type IntegrationState = DatasourceState<IntegrationStoreModel>;

export type CreateIntegrationParams = CreateDatasourceParams;
